import React from 'react';
import { BookOpen, Shield, Flag } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-130">
      <div className="max-w-4xl mx-auto" data-id="element-131">
        <div className="text-center mb-12" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-133">
            The Legacy Preservation Framework
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-134">
            This bundle uses a unique 3-pillar approach to cultural survival.
            Instead of just debating politics, we focus on strengthening your
            core foundation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-135">
          <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-navy text-center" data-id="element-136">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-137">
              <Shield className="text-navy" size={32} data-id="element-138" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-139">Character</h3>
            <p className="text-gray-600 text-sm" data-id="element-140">
              Build the unshakeable moral fortitude required to stand firm when
              the culture demands compliance.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-patriot-red text-center transform md:-translate-y-4" data-id="element-141">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-142">
              <BookOpen className="text-patriot-red" size={32} data-id="element-143" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-144">History</h3>
            <p className="text-gray-600 text-sm" data-id="element-145">
              Arm yourself with the true, unedited story of American
              exceptionalism to counter modern revisionism.
            </p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-gold text-center" data-id="element-146">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-147">
              <Flag className="text-gold" size={32} data-id="element-148" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-149">Identity</h3>
            <p className="text-gray-600 text-sm" data-id="element-150">
              Reclaim what it means to be a patriot and pass that proud heritage
              down to the next generation.
            </p>
          </div>
        </div>

        <div className="bg-navy text-white p-8 rounded-xl text-center shadow-lg" data-id="element-151">
          <p className="text-lg md:text-xl font-medium italic" data-id="element-152">
            "You won't just know what you believe; you'll know how to defend it
            and pass it on to your children so the American legacy never dies."
          </p>
        </div>
      </div>
    </section>;
}